import React from 'react';
import { Eye, ArrowLeftToLine } from 'lucide-react';
import { usePage, router } from '@inertiajs/react';
import { Button } from './Button';

export function ImpersonationBanner() {
  const { props } = usePage();
  const impersonating = props.impersonating;

  if (!impersonating) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-full bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950 shadow-lg">
      <Eye size={16} />
      <span>
        Viewing as <strong>{impersonating.affiliate_name}</strong>
      </span>
      <Button
        variant="outline"
        size="sm"
        className="!rounded-full !border-amber-700 !bg-amber-600 !text-amber-950 hover:!bg-amber-700 !py-0.5 !px-2.5 !text-xs"
        onClick={() => router.delete(impersonating.stop_url)}
      >
        <ArrowLeftToLine size={14} className="mr-1" />
        Stop
      </Button>
    </div>
  );
}
